/* c8 ignore start */
import { PHISHING_SIMULATION } from "@/utils/services";

export const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),

  children: [
    {
      path: "phishing_simulation",
      name: "customer-phishing_simulation",
      component: () =>
        import(
          "@/modules/PhishingSimulations/views/Customer/customer.index.vue"
        ),
      redirect: {
        name: "customer-phishing_simulation-overview",
      },
      meta: {
        solutionId: PHISHING_SIMULATION,
      },
      children: [
        {
          path: "overview",
          name: "customer-phishing_simulation-overview",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Customer/overview-page/overview-page.index.vue"
            ),
        },
        {
          path: "phishing_campaigns",
          name: "customer-phishing_simulation-phishing_campaigns",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Customer/phishing-campaigns/phishing-campaigns.index.vue"
            ),
        },
        {
          path: "phishing_campaigns/campaign-overview",
          name: "customer-phishing_simulation-phishing_campaigns-campaign_overview",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Customer/campaign-details/campaign-details.index.vue"
            ),
        },
      ],
    },
  ],
};

export default {};
/* c8 ignore end */
